import React from "react";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";

const UserReportTable = ({ data }) => {
  const columns = [
    {
      Header: "First Name",
      accessor: "firstName",
      width: 100
    },
    {
      Header: "Last Name",
      accessor: "lastName",
      width: 100
    },
    {
      Header: "email",
      accessor: "email",
      width: 200
    },
    {
      Header: "Active",
      accessor: (d) => {
        return d.active ? "yes" : "no";
      },
      width: 80
    },
    {
      Header: "Staff",
      accessor: (d) => {
        return d.staff ? "yes" : "no";
      },
      width: 80
    },
    {
      Header: "System Admin",
      accessor: (d) => {
        return d.sysAdmin ? "yes" : "no";
      },
      width: 80
    },
    {
      Header: "Portal User",
      accessor: (d) => {
        return d.portalUser ? "yes" : "no";
      },
      width: 80
    },
    {
      Header: "Modules & Roles",
      accessor: "moduleRole",
      width: 200
    },
    {
      Header: "Portal User Systems",
      accessor: "portalUserSystems",
      width: 200
    },
    {
      Header: "Portal User LHDs",
      accessor: "portalUserLhds",
      width: 200
    },
    {
      Header: "Portal User Inst.",
      accessor: "portalUserInstitutions",
      width: 200
    }
  ];
  return <DtsReactTable columns={columns} data={data} headerColor='ddw' showPagination showGlobalFilter />;
};

export default UserReportTable;
